const emptyFunc = () => {
    return;
};
const defaultSplitter = (str) => str.split('');
export { emptyFunc, defaultSplitter };
